import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const dot = (color, size = 14) => L.divIcon({ className: "", iconSize: [size, size],
  html: `<span style="display:block;width:${size}px;height:${size}px;border-radius:9999px;background:${color};border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></span>` });

export const MarketMap = ({ home, items }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !home) { return undefined; }
    const map = L.map(ref.current, { scrollWheelZoom: false }).setView(home, 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { attribution: "© OpenStreetMap", maxZoom: 18 }).addTo(map);
    L.marker(home, { icon: dot("#142f39", 18) }).addTo(map).bindPopup("Votre foyer");
    const pts = [home];
    items.filter((m) => m.geo).forEach((m) => {
      pts.push(m.geo);
      L.marker(m.geo, { icon: dot("#ea580c") }).addTo(map).bindPopup(`<b>${m.title.replace(/</g, "")}</b><br>${m.price} € · ${m.distance_km ?? "?"} km`);
    });
    const near = pts.filter((p) => Math.abs(p[0] - home[0]) < 0.5 && Math.abs(p[1] - home[1]) < 0.5);
    if (near.length > 1) map.fitBounds(near, { padding: [30, 30] });
    return () => map.remove();
  }, [home, items]);
  if (!home) return null;
  return <div ref={ref} className="card-surface relative z-0 h-72 overflow-hidden" data-testid="market-map" />;
};
